exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-input__append-outer{margin-top:0;margin-bottom:0}", ""]);

// exports
